import React from 'react';
import Location from '../../../UI/Icons/Location';

export const renderSlides = (slides) =>
  slides.map((slide) => (
    <div className="c-about-wfa-everyday__slide">
      <div className="c-about-wfa-everyday__slide-image">
        <img src={slide.image.url} alt={slide.image.alt} />
      </div>
      <div className="c-about-wfa-everyday__slide__text eyebrow-2">
        <div className="c-about-wfa-everyday__slide-icon">
          <Location />
        </div>
        <p className="c-about-wfa-everyday__slide-location">{slide.location}</p>
      </div>
    </div>
  ));
